import { TMS_DOMAIN } from '~/shared/config/env'
import { AsyncGridColumns, ColumnDate, ColumnLink } from '~/shared/ui/AsyncGrid'
import { ChipStatus } from '~/shared/ui/Chips'
import { FileExportLink } from '~/shared/ui/FileExport'
import { GridRow } from './types'

export const columns: AsyncGridColumns<GridRow> = [
  {
    headerName: 'column.date',
    field: 'updatedAt',
    minWidth: 160,
    renderCell: ({ row, value }) => (
      <ColumnLink to={`${row.id}/details`}>
        <ColumnDate type='date' value={value} />
      </ColumnLink>
    ),
  },
  {
    headerName: 'column.car',
    field: 'plateNumber',
    minWidth: 160,
    renderCell: ({ row, value }) => (
      <ColumnLink href={`${TMS_DOMAIN}cars/${row.carExtId}`}>
        {value}
      </ColumnLink>
    ),
  },
  {
    headerName: 'column.car brand model',
    field: 'carBrandModel',
    minWidth: 210,
    sortable: false,
  },
  {
    headerName: 'column.mileage',
    field: 'mileage',
    minWidth: 120,
  },
  {
    headerName: 'column.inspection reason',
    field: 'reason',
    sortable: false,
    minWidth: 200,
  },
  {
    headerName: 'column.driver full name',
    field: 'driverFullName',
    minWidth: 200,
    renderCell: ({ row, value }) =>
      row.driverExtId ? (
        <ColumnLink href={`${TMS_DOMAIN}drivers/${row.driverExtId}`}>
          {value}
        </ColumnLink>
      ) : (
        value
      ),
  },
  {
    headerName: 'column.has damages',
    field: 'hasDamages',
    minWidth: 190,
    sortable: false,
    renderCell: ({ value }) => (
      <ChipStatus
        variant={value ? 'green' : 'red'}
        labelI18n={value ? 'column.yes' : 'column.no'}
      />
    ),
  },
  {
    headerName: 'column.total cost',
    field: 'totalCost',
    minWidth: 160,
    sortable: false,
    renderCell: ({ value }) => (value || 0).toLocaleString(),
  },
  {
    headerName: 'column.has car photos',
    field: 'hasCarPhotos',
    minWidth: 250,
    sortable: false,
    renderCell: ({ value }) => (
      <ChipStatus
        variant={value ? 'green' : 'red'}
        labelI18n={value ? 'column.yes' : 'column.no'}
      />
    ),
  },
  {
    headerName: 'column.has documents loss',
    field: 'hasDocumentsLoss',
    minWidth: 160,
    sortable: false,
    renderCell: ({ value }) => (
      <ChipStatus
        variant={value ? 'green' : 'red'}
        labelI18n={value ? 'column.yes' : 'column.no'}
      />
    ),
  },
  {
    headerName: 'column.mechanic full name',
    field: 'mechanicFullName',
    minWidth: 200,
    sortable: false,
  },
  {
    headerName: 'column.comment',
    field: 'comment',
    minWidth: 200,
    sortable: false,
  },
  {
    headerName: 'column.region',
    field: 'regionTitle',
    minWidth: 160,
    sortable: false,
  },
  {
    headerName: 'column.subdivision',
    field: 'subdivisionTitle',
    minWidth: 160,
    sortable: false,
  },
  {
    headerName: 'column.actions',
    field: 'actions',
    minWidth: 120,
    sortable: false,
    renderCell: ({ row }) => {
      return (
        row?.inspectionReport?.originalUrlDownload && (
          <FileExportLink
            tooltipText='column.download inspection report'
            filepath={row?.inspectionReport?.originalUrlDownload}
          />
        )
      )
    },
  },
]
